enum TaskActions {
  click = "click",
  pause = "pause",
  resume = "resume",
  restart = "restart",
  cancel = "cancel",
  close = "close",
}
export default TaskActions;
